export const dadosCertificadoDto = {
  id: null,
  cpf: null,
  nome: null,
  idCurso: null,
  dataFim: null,
  nomeCurso: null,
  dataInicio: null,
  tipoSolucao: null,
  cargaHoraria: null,
  descricaoConteudo: null,
  composicaoConteudo: null,
};
